import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css'
import element from './element-ui/index'
import './assets/css/style.css'
import router from './router'
import axios from 'axios'
import store from './store/store'
import './assets/icon/iconfont.css'
import './assets/css/modify.css'
import tools from './assets/js/tools'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false

Vue.use(element);
Vue.use(VueClipboard)
    // 配置axios
axios.defaults.baseURL = '/developer'
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$ajax = axios

Vue.prototype.tools = tools

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js